import React, { FC } from 'react'
import { Link } from 'react-router-dom'
import ArrowIcon from '../../images/arrow-icon.svg'

interface Props {
  content: {
    title: string
    content: string
    bg?: string
    link: {
      type: 'btn' | 'arrow'
      text?: string
      url: string
    }
  }
}

const ContentBanner: FC<Props> = ({ content }) => {
  let bannerLink

  if (content.link.type === 'btn') {
    bannerLink = (
      <Link to={content.link.url} className="btn btn-secondary border-0 mt-2">
        {content.link.text}
      </Link>
    )
  } else {
    bannerLink = (
      <Link to={content.link.url} className="float-right">
        <img src={ArrowIcon} alt={content.title} />
      </Link>
    )
  }

  return (
    <div className="row h-100">
      <div className="col-12 mb-4 mb-lg-0">
        <div className={`content-banner-wrap bg-white p-4 ${content.bg} h-100`}>
          <div className="content-banner-inner p-2 d-inline-block">
            <h4 className="mt-5 mb-3">{content.title}</h4>
            <p dangerouslySetInnerHTML={{ __html: content.content }}></p>
            {bannerLink}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContentBanner
